require('./contractEasyLoanTypeCErrorStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
const { catalogue, analyticsId, recordEasyLoanCApprovedWizardError } = require('../analytics/contractEasyLoanApprovedTypeC.tracking');

const contractEasyLoanTypeCErrorStep = ({ phoneNumber, heading = "contractEasyTypeCLoanError-okTitle", message = "contractEasyTypeCLoanError-okMessage", immContractEasyLoanTypeC } ) => {
    const title = formatText(heading);
    const goBackLink = {
        label: formatText('contractEasyLoanError-goBackLinkText').toUpperCase(),
        url: 'myprofile/'
    };

    return (
        <article className="contract-easy-loan-error-step row no-gutter">
            <div className="col-xs-12">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackLink}
                    tealium={catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]({ data: immContractEasyLoanTypeC.get('minTae'), errorMessage: title })}
                    isSecondVersion
                    onComponentDidMountCallback={recordEasyLoanCApprovedWizardError}
                >
                    <section className="row">
                        <FormattedText injectedStrings={[ phoneNumber ]} value={message} className="contract-easy-loan-error-step__block" />
                    </section>
                </WizardError>
            </div>
        </article>
    );
};

contractEasyLoanTypeCErrorStep.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
};

module.exports = contractEasyLoanTypeCErrorStep;
